import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const cls = "w-full bg-white border hairline px-3 py-2.5 outline-none focus:border-[var(--ink)] transition-colors text-sm";

export default function EnquiryForm({ artworkSlug, label }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null); // null | sending | sent | error
  const [err, setErr] = useState("");
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault(); setStatus("sending"); setErr("");
    try {
      await api.post("/enquiries", { artwork_slug: artworkSlug, ...form });
      setStatus("sent");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail)); setStatus("error");
    }
  };

  if (status === "sent") return (
    <div className="mt-6 pt-6 border-t hairline" data-testid="enquiry-sent">
      <div className="label mb-2">Enquiry</div>
      <p className="text-sm text-[var(--muted)] leading-relaxed">Thank you — your enquiry about {label} has been received. You'll hear back soon.</p>
    </div>
  );

  return (
    <div className="mt-6 pt-6 border-t hairline">
      {!open ? (
        <button onClick={() => setOpen(true)} data-testid="enquire-toggle"
          className="group inline-flex items-center gap-2 font-display uppercase tracking-[0.12em] text-sm">
          <span className="border-b border-transparent group-hover:border-[var(--ink)] transition-colors pb-1">Enquire</span>
          <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
        </button>
      ) : (
        <form onSubmit={submit} className="space-y-3" data-testid="enquiry-form">
          <div className="label mb-1">Enquire about {label}</div>
          <input required placeholder="Name" value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="enquiry-name" className={cls} />
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="enquiry-email" className={cls} />
          <textarea rows={3} placeholder="Message (optional)" value={form.message} onChange={(e) => set("message", e.target.value)} data-testid="enquiry-message" className={cls} />
          {err && <div className="text-xs text-red-700" data-testid="enquiry-error">{err}</div>}
          <div className="flex items-center gap-4">
            <button type="submit" disabled={status === "sending"} data-testid="enquiry-submit"
              className="bg-[var(--ink)] text-[var(--paper)] font-display uppercase tracking-[0.1em] text-xs px-6 py-3 hover:opacity-80 transition-opacity">
              {status === "sending" ? "Sending…" : "Send enquiry"}
            </button>
            <button type="button" onClick={() => setOpen(false)} className="label hover:opacity-50">Cancel</button>
          </div>
        </form>
      )}
    </div>
  );
}
